import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { base64ToFile, Images, KeyPurpose } from 'utils';
import { UploadedSignature } from '../../../../../fragments/schedule/core/common/uploadedSignature';
import { uploadFile } from 'store';
import { useFormBuilder } from '../../formContext';

export const DrawSignatureElement = ({ item, value, onChange, readOnly, width, blockWidth }) => {
    const [isDrawing, setIsDrawing] = useState(false);
    const sigCanvas = useRef(null);
    const { onDragStart, setOnDragStart } = useFormBuilder();

    const getSignature = async (name) => {
        const signatureData = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');
        if (sigCanvas?.current && signatureData && isDrawing) {
            const convertedFile = base64ToFile(signatureData, 'signature.png');
            if (convertedFile) {
                try {
                    const storedFile = await uploadFile(convertedFile, KeyPurpose.SIGNATURE);
                    const info = {
                        file: {
                            ...storedFile,
                            name: 'signature',
                        },
                    };
                    onChange(info?.file);
                } catch (e) {
                    // setUploadLoader(false);
                }
            }
        }
    };

    return (
        <div className="flex-justify-align-center">
            <div className="signature-upload-draw-box" style={{ width: width ? width : 550 }}>
                <div onMouseEnter={() => setOnDragStart(true)} onMouseLeave={() => setOnDragStart(false)} className="canvas-wrapper">
                    <SignatureCanvas
                        onEnd={() => {
                            if (!readOnly) {
                                getSignature(item?.name);
                            }
                        }}
                        ref={sigCanvas}
                        penColor="black"
                        canvasProps={{
                            width: 480,
                            height: 100,
                            className: 'sigCanvas',
                            style: { pointerEvents: readOnly ? 'none' : 'auto' },
                        }}
                        onBegin={() => {
                            if (!readOnly) setIsDrawing(true);
                        }}
                    />
                    <div className="canvas-line" />
                    {!readOnly && (
                        <div className="clear-canvas-btn">
                            <button
                                type="button"
                                onClick={() => {
                                    onChange(null);
                                    if (sigCanvas?.current) {
                                        sigCanvas.current.clear();
                                        setIsDrawing(false);
                                    }
                                }}
                            >
                                <img src={Images.clearSignature} alt="icon" />
                                <p>Clear</p>
                            </button>
                        </div>
                    )}
                </div>

                {item?.value && (
                    <div style={{ marginTop: 20 }}>
                        <UploadedSignature
                            textWidth={blockWidth === 'calc(50% - 6px)' ? 170 : 330}
                            handleRemoveUploaded={() => {
                                onChange(null);
                                if (sigCanvas?.current) {
                                    sigCanvas.current.clear();
                                    setIsDrawing(false);
                                }
                            }}
                            currentFile={{ file: item?.value }}
                            alreadyUploaded={true}
                            alwaysDelete={true}
                            noDel={readOnly}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
